import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {RootState} from '../../store'
import * as T from '../../services/types'

export interface IState {
  isFetchData: boolean
  filterPlantAssignment: T.IFetchPlantAssignmentParams
  filterPlants: T.IFetchPlantsParams
  filterSalesOffices: T.IFetchSalesOffices
  filterSalesAreaAssignment: T.IFetchSalesAreaAssignmentParams
  filterBasicPrices: T.IFetchBasicPricesParams
  filterNonJBPPrices: T.IFetchNonJBPPricesParams
  filterIncoterms: T.IFetchIncotermsParams
  filterTermOfPayments: T.IFetchTermOfPaymentsParams
  filterTransports: T.IFetchTransportsParams
  filterBankAccount: T.IFetchBankAccountsParams
  filterRoute: T.IFetchRoutesParams
  filterNews: T.IFetchNewsParams
  filterUser: T.IFetchUsersParams
  filterRole: T.IFetchRoleParams
  filterMenu: T.IFetchMenusParams
  filterSIPLevel: T.IFetchApprovalLevelParams
  filterSOLevel: T.IFetchApprovalLevelParams
  filterContractLevel: T.IFetchApprovalLevelParams
  filterUserLevel: T.IFetchUserLevelParams
  filterSettingConfig: T.IFetchSettingConfigParams
  filterDate: T.IFetchConfigDateParams
  filterSupplyPoint: T.IFetchMasterSupplyPoint
  filterLogSAP: T.IFetchLogSAPParams
  filterLogH2H: T.IFetchLogH2HParams
  filterLogAPI: T.IFetchLogAPIParams
  filterLogSalesOrder: T.IFetchLogSalesOrderParams
  filterAuditTrails: T.IFetchAuditTrailsParams
  filterPPN: T.IFetchPPNParams
  filterCustomer: T.IFetchCustomerParams
  filterMaterial: T.IFetchMaterialParams
  filterConfigLetter: T.IFetchConfigLetterParams
  filterConfigOptionalText: T.IFetchConfigOptionalTextParams
  filterOrders: T.IFetchOrdersParams
  filterSIPOrders: T.IFetchSIPOrdersParams
  filterContracts: T.IFetchOrderContractsParams
  filterSO: T.IFetchSOParams
  filterDeliveryOrders: T.IFetchDeliveryOrdersParams
  filterLogMasterData: T.IFetchLogMasterDataParams
  filterLogAuth: T.IFetchLogParams
  filterLogPeruri: T.IFetchLogPeruriParams
  filterConfigSigning: T.IFetchConfigSigningParams
  filterConfigPaymentDueDate: T.IFetchConfigPaymentDueDateParams
  filterConfigFile: T.IFetchConfigFileParams
  filterMasterJBPType: T.IFetchMasterJBPType
  filterMasterJBP: T.IFetchMasterJBP
  filterMasterPricing: T.IFetchMasterPricing
  filterLogQueue: T.ILogQueue
}

export const initialState: IState = {
  isFetchData: false,
  filterLogQueue: {
    activities: '',
    username: '',
    status: '',
    message: '',
    created_at: '',
    updated_at: '',
    per_page: 25,
  },
  filterMasterJBPType: {
    per_page: 25,
    code: '',
    company_code: '',
    type: '',
  },
  filterMasterJBP: {
    per_page: 25,
    code: '',
    company_code: '',
    jbp_type_desc: '',
    jbp_type_code: '',
    customer_code: '',
    customer_name: '',
    province_id: '',
    city_id: '',
    valid_from: '',
    valid_to: '',
  },
  filterMasterPricing: {
    per_page: 25,
    company_code: '',
    company_desc: '',
    jbp_type_desc: '',
    jbp_type_code: '',
    plant_code: '',
    plant_desc: '',
    incoterm: '',
    product_code: '',
    product_desc: '',
    price: '',
    valid_from: '',
    valid_to: '',
    is_active: '',
    is_jbp: '',
  },
  filterPlantAssignment: {
    per_page: 25,
    dc_description: '',
    distribution_channel: '',
    plant: '',
    plant_desc: '',
    sales_org_code: '',
    sales_org_desc: '',
  },
  filterPlants: {
    per_page: 25,
    address: '',
    city_code: '',
    name1: '',
    from_date: '',
    to_date: '',
  },
  filterSalesOffices: {
    per_page: 25,
    controlling_area: '',
    from_date: '',
    sales_office: '',
    to_date: '',
  },
  filterSalesAreaAssignment: {
    per_page: 25,
    company_name: '',
    controlling_area: '',
    dc_description: '',
    description: '',
    distribution_channel: '',
    division: '',
    division_desc: '',
    sales_office: '',
    sales_office_from_date: '',
    sales_office_id: '',
    sales_office_to_date: '',
    sales_org: '',
  },
  filterBasicPrices: {
    per_page: 25,
    price: '',
    product_name: '',
    product_code: '',
    created_at: '',
    created_by: '',
    updated_at: '',
  },
  filterNonJBPPrices: {
    per_page: 25,
    city_name: '',
    is_active: '',
    product_code: '',
    product_name: '',
    region_name: '',
    sales_org_code: '',
    purchase_price: '',
    sales_org_code2: '',
    selling_price: '',
    minimum_price: '',
    discount: '',
    description: '',
    price: '',
  },
  filterIncoterms: {
    per_page: 25,
    code: '',
  },
  filterTermOfPayments: {
    per_page: 25,
    code: '',
    top_desc: '',
  },
  filterTransports: {
    per_page: 25,
    name_en: '',
    name_id: '',
  },
  filterBankAccount: {
    per_page: 25,
    bank: '',
    bank_account: '',
    bank_clearing_acct: '',
    bank_gl_account: '',
    sales_org_code: '',
    status: '',
  },
  filterRoute: {
    per_page: 25,
    route: '',
    route_desc: '',
    sales_org_code: '',
  },
  filterNews: {
    per_page: 25,
    title: '',
    content: '',
    flag: '',
    url: '',
  },
  filterUser: {
    per_page: 25,
    name: '',
    email: '',
    nama_pengguna: '',
    role_name: '',
  },
  filterRole: {
    per_page: 25,
    name: '',
    sales_org_code: '',
  },
  filterMenu: {
    per_page: 25,
    name: '',
    parent: '',
    sort: '',
    name_ind: '',
  },
  filterSIPLevel: {
    per_page: 25,
    level: '',
    max_quantity: '',
    min_quantity: '',
    payment_type: '',
    product_type: '',
    sales_org_code: '',
    sector_id: '',
  },
  filterSOLevel: {
    per_page: 25,
    level: '',
    max_quantity: '',
    min_quantity: '',
    payment_type: '',
    product_type: '',
    sales_org_code: '',
    sector_id: '',
  },
  filterContractLevel: {
    per_page: 25,
    level: '',
    max_quantity: '',
    min_quantity: '',
    payment_type: '',
    product_type: '',
    sales_org_code: '',
    sector_id: '',
  },
  filterUserLevel: {
    per_page: 25,
    name: '',
  },
  filterSettingConfig: {
    per_page: 25,
    feature: '',
    label: '',
    status: '',
    updated_at: '',
  },
  filterDate: {
    per_page: 25,
    is_active: '',
    max_tonnase: '',
    minimum_tonnase: '',
    sales_org_code: '',
    sector_id: '',
    time: '',
    time_type: '',
  },
  filterLogSAP: {
    per_page: 25,
    transaction_number: '',
    created_at: '',
    ip_response: '',
    message: '',
    request_type: '',
    request: '',
    response: '',
    status: '',
    updated_at: '',
  },
  filterLogH2H: {
    per_page: 25,
    bank_name: '',
    created_at: '',
    http: '',
    ip_request: '',
    ip_response: '',
    no_penebusan: '',
    pengirim_request: '',
    request_type: '',
    status: '',
    timestamp_request: '',
    timestamp_response: '',
    pengirim_response: '',
    request: '',
    response: '',
  },
  filterLogAPI: {
    per_page: 25,
    username: '',
    agent: '',
    body: '',
    created_at: '',
    error_code: '',
    message: '',
    ip_addres: '',
    method: '',
    path: '',
    request_type: '',
    response: '',
    status: '',
    updated_at: '',
  },
  filterLogSalesOrder: {
    per_page: 5,
    so_number: '',
    customer_name: '',
    flag: '',
    message: '',
    execution_date: '',
    billing_number_sap: '',
    sap_number: '',
    dp_req_sap: '',
    clearing_doc_1: '',
    clearing_doc_2: '',
    bank_payment: ''  
  },
  filterAuditTrails: {
    per_page: 25,
    activities: '',
    date: '',
    username: '',
  },
  filterPPN: {
    per_page: 25,
    ppn: '',
    created_at: '',
    updated_at: '',
  },
  filterCustomer: {
    per_page: 25,
    company_type: '',
    company_type_description: '',
    customer_account_group: '',
    customer_code: '',
    email: '',
    name: '',
    no_telp: '',
    street1: '',
    text: '',
  },
  filterMaterial: {
    page: 1,
    per_page: 25,
    company_code: '',
    distribution_channel: '',
    material_description: '',
    material_group: '',
    material_number: '',
    plant: '',
    plant_desc: '',
    plant_detail: '',
  },
  filterConfigLetter: {
    per_page: 25,
    created_at: '',
    lang: '',
    module: '',
    sales_org_code: '',
    updated_at: '',
  },
  filterConfigOptionalText: {
    per_page: 25,
    created_at: '',
    module: '',
    sales_org_code: '',
    sector_id: '',
    updated_at: '',
  },
  filterOrders: {
    per_page: 25,
    page: 1,
    customer_name: '',
    customer_name_orderby: '',
    from_date: '',
    po_number: '',
    po_number_orderby: '',
    regarding: '',
    sales_org_code: '',
    sector_id: '',
    status: '',
    to_date: '',
    total_request_price: '',
    total_request_quantum: '',
    outstanding_data: '',
  },
  filterSIPOrders: {
    per_page: 25,
    page: 1,
    created_at: '',
    customer_name: '',
    customer_name_orderby: '',
    from_date: '',
    po_number: '',
    estimate_date: '',
    perihal: '',
    sales_org_code: '',
    po_number_orderby: '',
    price: '',
    product_type: '',
    sales_org_name: '',
    sector_id: '',
    SIP_number: '',
    status: '',
    to_date: '',
    total_quantum: '',
    total_request_price: '',
    total_request_quantum: '',
    outstanding_data: '',
  },
  filterContracts: {
    per_page: 25,
    contract_number: '',
    customer_name: '',
    customer_name_orderby: '',
    estimate_date: '',
    from_date: '',
    grand_total: '',
    order_sub_id: '',
    payment_type: '',
    po_number: '',
    po_number_orderby: '',
    product_type: '',
    regarding: '',
    sales_org_code: '',
    sales_org_name: '',
    sector_id: '',
    sap_number: '',
    sip_number: '',
    status: '',
    to_date: '',
    total_price: '',
    total_quantum: '',
    validity_date_from: '',
    validity_date_to: '',
  },
  filterSO: {
    per_page: 25,
    booking_code: '',
    customer_name: '',
    from_date: '',
    incoterm: '',
    po_number: '',
    price_after_ppn: '',
    sales_org_code: '',
    sap_number: '',
    sector_id: '',
    sip_number: '',
    so_number: '',
    status: '',
    to_date: '',
    total_price_so: '',
    total_quantum_so: '',
    customer_name_orderby: '',
    payment_type: '',
    po_number_orderby: '',
    product_type: '',
  },
  filterSupplyPoint: {
    per_page: 5,
    sales_org_code: '',
    province_id: '',
    city_id: '',
    plant_code: '',
    plant: '',
    secound_sales_group: '',
    status: '',
  },
  filterDeliveryOrders: {
    per_page: 25,
    customer_code: '',
    customer_name: '',
    do_created: '',
    do_number: '',
    produsen: '',
    qty: '',
    so_created: '',
    so_number: '',
    delivery_item: '',
    do_date: '',
    material_group: '',
    material_number: '',
    plant: '',
    plant_desc: '',
    sales_org_code: '',
  },
  filterLogMasterData: {
    per_page: 25,
    username: '',
    error_code: '',
    created_at: '',
    agent: '',
    body: '',
    ip_addres: '',
    method: '',
    path: '',
    request_type: '',
    response: '',
    status: '',
  },
  filterLogAuth: {
    per_page: 25,
    username: '',
    error_code: '',
    agent: '',
    body: '',
    created_at: '',
    method: '',
    path: '',
    ip_addres: '',
    message: '',
    request_type: '',
    response: '',
    status: '',
    updated_at: '',
  },
  filterLogPeruri: {
    per_page: 25,
    flag: 1,
    agent: '',
    body: '',
    created_at: '',
    method: '',
    ip_addres: '',
    header: '',
    endpoint: '',
    response: '',
    status: '',
    updated_at: '',
  },
  filterConfigSigning: {
    module: '',
    sales_org_code: '',
    product_type: '',
    tonnage_limit: '',
    signer_name: '',
    signer_position: '',
  },
  filterConfigPaymentDueDate: {
    sales_org_code: '',
    sector_id: ''
  },
  filterConfigFile: {
    type: '',
    sales_org_code: ''
  }
}

/**
 * Slice
 */
const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setIsFetchData: (state: IState, action: PayloadAction<boolean>) => {
      state.isFetchData = action.payload
    },
    setFilterLogQueue: (
      state: IState,
      action: PayloadAction<T.ILogQueue>
    ) => {
      state.filterLogQueue = action.payload
    },
    resetFilterLogQueue: (state: IState) => {
      state.filterLogQueue = initialState.filterLogQueue
    },
    setFilterMasterJBPType: (
      state: IState,
      action: PayloadAction<T.IFetchMasterJBPType>
    ) => {
      try {
        const serializedState = JSON.stringify(action.payload);
        localStorage.setItem('redux-mjbpt-filter', serializedState);
      } catch (e) {
        console.log("err", e)
      }
      state.filterMasterJBPType = action.payload
    },
    resetFilterMasterJBPType: (state: IState) => {
      localStorage.removeItem('redux-mjbpt-filter');
      state.filterMasterJBPType = initialState.filterMasterJBPType
    },
    setFilterMasterJBP: (
      state: IState,
      action: PayloadAction<T.IFetchMasterJBP>
    ) => {
      try{
        localStorage.setItem('redux-jbp-pricing-filter', JSON.stringify(action.payload))
      }catch(e){}
      state.filterMasterJBP = action.payload
    },
    resetFilterMasterJBP: (state: IState) => {
      localStorage.removeItem('redux-jbp-pricing-filter')
      state.filterMasterJBP = initialState.filterMasterJBP
    },
    setFilterMasterPricing: (
      state: IState,
      action: PayloadAction<T.IFetchMasterPricing>
    ) => {
      try{
        localStorage.setItem('redux-master-pricing-filter', JSON.stringify(action.payload))
      }catch(e){}
      state.filterMasterPricing = action.payload
    },
    resetFilterMasterPricing: (state: IState) => {
      localStorage.removeItem('redux-master-pricing-filter')
      state.filterMasterPricing = initialState.filterMasterPricing
    },
    setFilterPlantAssignment: (
      state: IState,
      action: PayloadAction<T.IFetchPlantAssignmentParams>
    ) => {
      state.filterPlantAssignment = action.payload
    },
    resetFilterPlantAssignment: (state: IState) => {
      state.filterPlantAssignment = initialState.filterPlantAssignment
    },
    setFilterPlants: (state: IState, action: PayloadAction<T.IFetchPlantsParams>) => {
      state.filterPlants = action.payload
    },
    resetFilterPlants: (state: IState) => {
      state.filterPlants = initialState.filterPlants
    },
    setFilterSalesOffices: (state: IState, action: PayloadAction<T.IFetchSalesOffices>) => {
      state.filterSalesOffices = action.payload
    },
    resetFilterSalesOffices: (state: IState) => {
      state.filterSalesOffices = initialState.filterSalesOffices
    },
    setFilterSalesAreaAssignment: (
      state: IState,
      action: PayloadAction<T.IFetchSalesAreaAssignmentParams>
    ) => {
      state.filterSalesAreaAssignment = action.payload
    },
    resetFilterSalesAreaAssignment: (state: IState) => {
      state.filterSalesAreaAssignment = initialState.filterSalesAreaAssignment
    },
    setFilterBasicPrices: (state: IState, action: PayloadAction<T.IFetchBasicPricesParams>) => {
      state.filterBasicPrices = action.payload
    },
    resetFilterBasicPrices: (state: IState) => {
      state.filterBasicPrices = initialState.filterBasicPrices
    },
    setFilterNonJBPPrices: (state: IState, action: PayloadAction<T.IFetchNonJBPPricesParams>) => {
      state.filterNonJBPPrices = action.payload
    },
    resetFilterNonJBPPrices: (state: IState) => {
      state.filterNonJBPPrices = initialState.filterNonJBPPrices
    },
    setFilterIncoterms: (state: IState, action: PayloadAction<T.IFetchIncotermsParams>) => {
      state.filterIncoterms = action.payload
    },
    resetFilterIncoterms: (state: IState) => {
      state.filterIncoterms = initialState.filterIncoterms
    },
    setFilterTermOfPayments: (
      state: IState,
      action: PayloadAction<T.IFetchTermOfPaymentsParams>
    ) => {
      state.filterTermOfPayments = action.payload
    },
    resetFilterTermOfPayments: (state: IState) => {
      state.filterTermOfPayments = initialState.filterTermOfPayments
    },
    setFilterTransports: (state: IState, action: PayloadAction<T.IFetchTransportsParams>) => {
      state.filterTransports = action.payload
    },
    resetFilterTransports: (state: IState) => {
      state.filterTransports = initialState.filterTransports
    },
    setFilterBankAccount: (state: IState, action: PayloadAction<T.IFetchBankAccountsParams>) => {
      state.filterBankAccount = action.payload
    },
    resetFilterBankAccount: (state: IState) => {
      state.filterBankAccount = initialState.filterBankAccount
    },
    setFilterRoute: (state: IState, action: PayloadAction<T.IFetchRoutesParams>) => {
      state.filterRoute = action.payload
    },
    resetFilterRoute: (state: IState) => {
      state.filterRoute = initialState.filterRoute
    },
    setFilterNews: (state: IState, action: PayloadAction<T.IFetchNewsParams>) => {
      state.filterNews = action.payload
    },
    resetFilterNews: (state: IState) => {
      state.filterNews = initialState.filterNews
    },
    setFilterUser: (state: IState, action: PayloadAction<T.IFetchUsersParams>) => {
      state.filterUser = action.payload
    },
    resetFilterUser: (state: IState) => {
      state.filterUser = initialState.filterUser
    },
    setFilterRole: (state: IState, action: PayloadAction<T.IFetchRoleParams>) => {
      state.filterRole = action.payload
    },
    resetFilterRole: (state: IState) => {
      state.filterRole = initialState.filterRole
    },
    setFilterMenu: (state: IState, action: PayloadAction<T.IFetchMenusParams>) => {
      state.filterMenu = action.payload
    },
    resetFilterMenu: (state: IState) => {
      state.filterMenu = initialState.filterMenu
    },
    setFilterSIPLevel: (state: IState, action: PayloadAction<T.IFetchApprovalLevelParams>) => {
      state.filterSIPLevel = action.payload
    },
    resetFilterSIPLevel: (state: IState) => {
      state.filterSIPLevel = initialState.filterSIPLevel
    },
    setFilterSOLevel: (state: IState, action: PayloadAction<T.IFetchApprovalLevelParams>) => {
      state.filterSOLevel = action.payload
    },
    resetFilterSOLevel: (state: IState) => {
      state.filterSOLevel = initialState.filterSOLevel
    },
    setFilterContractLevel: (state: IState, action: PayloadAction<T.IFetchApprovalLevelParams>) => {
      state.filterContractLevel = action.payload
    },
    resetFilterContractLevel: (state: IState) => {
      state.filterContractLevel = initialState.filterContractLevel
    },
    setFilterUserLevel: (state: IState, action: PayloadAction<T.IFetchUserLevelParams>) => {
      state.filterUserLevel = action.payload
    },
    resetFilterUserLevel: (state: IState) => {
      state.filterUserLevel = initialState.filterUserLevel
    },
    setFilterSettingConfig: (state: IState, action: PayloadAction<T.IFetchSettingConfigParams>) => {
      state.filterSettingConfig = action.payload
    },
    resetFilterSettingConfig: (state: IState) => {
      state.filterSettingConfig = initialState.filterSettingConfig
    },
    setFilterDate: (state: IState, action: PayloadAction<T.IFetchConfigDateParams>) => {
      state.filterDate = action.payload
    },
    resetFilterDate: (state: IState) => {
      state.filterDate = initialState.filterDate
    },
    setFilterLogSAP: (state: IState, action: PayloadAction<T.IFetchLogSAPParams>) => {
      state.filterLogSAP = action.payload
    },
    resetFilterLogSAP: (state: IState) => {
      state.filterLogSAP = initialState.filterLogSAP
    },
    setFilterLogH2H: (state: IState, action: PayloadAction<T.IFetchLogH2HParams>) => {
      state.filterLogH2H = action.payload
    },
    resetFilterLogH2H: (state: IState) => {
      state.filterLogH2H = initialState.filterLogH2H
    },
    setFilterLogAPI: (state: IState, action: PayloadAction<T.IFetchLogAPIParams>) => {
      state.filterLogAPI = action.payload
    },
    resetFilterLogAPI: (state: IState) => {
      state.filterLogAPI = initialState.filterLogAPI
    },
    setFilterLogSalesOrder: (state: IState, action: PayloadAction<T.IFetchLogSalesOrderParams>) => {
      try {
        localStorage.setItem('redux-log-so-filter', JSON.stringify(action.payload));
      } catch (e) {
        console.log("err", e)
      }
      state.filterLogSalesOrder = action.payload
    },
    resetFilterLogSalesOrder: (state: IState) => {
      localStorage.removeItem('redux-log-so-filter')
      state.filterLogSalesOrder = initialState.filterLogSalesOrder
    },
    setFilterAuditTrails: (state: IState, action: PayloadAction<T.IFetchAuditTrailsParams>) => {
      state.filterAuditTrails = action.payload
    },
    resetFilterAuditTrails: (state: IState) => {
      state.filterAuditTrails = initialState.filterAuditTrails
    },
    setFilterPPN: (state: IState, action: PayloadAction<T.IFetchPPNParams>) => {
      state.filterPPN = action.payload
    },
    resetFilterPPN: (state: IState) => {
      state.filterPPN = initialState.filterPPN
    },
    setFilterCustomer: (state: IState, action: PayloadAction<T.IFetchCustomerParams>) => {
      state.filterCustomer = action.payload
    },
    resetFilterCustomer: (state: IState) => {
      state.filterCustomer = initialState.filterCustomer
    },
    setFilterMaterial: (state: IState, action: PayloadAction<T.IFetchMaterialParams>) => {
      state.filterMaterial = action.payload
    },
    resetFilterMaterial: (state: IState) => {
      state.filterMaterial = initialState.filterMaterial
    },
    setFilterConfigLetter: (state: IState, action: PayloadAction<T.IFetchConfigLetterParams>) => {
      state.filterConfigLetter = action.payload
    },
    resetFilterConfigLetter: (state: IState) => {
      state.filterConfigLetter = initialState.filterConfigLetter
    },
    setFilterConfigOptionalText: (state: IState, action: PayloadAction<T.IFetchConfigOptionalTextParams>) => {
      state.filterConfigOptionalText = action.payload
    },
    resetFilterConfigOptionalText: (state: IState) => {
      state.filterConfigOptionalText = initialState.filterConfigOptionalText
    },
    setFilterOrders: (state: IState, action: PayloadAction<T.IFetchOrdersParams>) => {
      state.filterOrders = action.payload
    },
    resetFilterOrders: (state: IState) => {
      state.filterOrders = initialState.filterOrders
    },
    setFilterSIPOrders: (state: IState, action: PayloadAction<T.IFetchSIPOrdersParams>) => {
      state.filterSIPOrders = action.payload
    },
    resetFilterSIPOrders: (state: IState) => {
      state.filterSIPOrders = initialState.filterSIPOrders
    },
    setFilterContracts: (state: IState, action: PayloadAction<T.IFetchOrderContractsParams>) => {
      try{
        localStorage.setItem('redux-contract-filter', JSON.stringify(action.payload))
      }catch(e){}
      state.filterContracts = action.payload
    },
    resetFilterContracts: (state: IState) => {
      localStorage.removeItem('redux-contract-filter')
      state.filterContracts = initialState.filterContracts
    },
    setFilterSO: (state: IState, action: PayloadAction<T.IFetchSOParams>) => {
      try {
        const serializedState = JSON.stringify(action.payload);
        localStorage.setItem('redux-so-filter', serializedState);
      } catch (e) {
        console.log("err", e)
      }
      state.filterSO = action.payload
    },
    resetFilterSO: (state: IState) => {
      console.log("reset so")
      localStorage.removeItem('redux-so-filter');
      state.filterSO = initialState.filterSO
    },
    setFilterDelveryOrders: (
      state: IState,
      action: PayloadAction<T.IFetchDeliveryOrdersParams>
    ) => {
      state.filterDeliveryOrders = action.payload
    },
    resetFilterDelveryOrders: (state: IState) => {
      state.filterDeliveryOrders = initialState.filterDeliveryOrders
    },
    setFilterLogMasterData: (state: IState, action: PayloadAction<T.IFetchLogMasterDataParams>) => {
      state.filterLogMasterData = action.payload
    },
    resetFilterLogMasterData: (state: IState) => {
      state.filterLogMasterData = initialState.filterLogMasterData
    },
    setFilterLogAuth: (state: IState, action: PayloadAction<T.IFetchLogParams>) => {
      state.filterLogAuth = action.payload
    },
    resetFilterLogAuth: (state: IState) => {
      state.filterLogAuth = initialState.filterLogAuth
    },
    setFilterLogPeruri: (state: IState, action: PayloadAction<T.IFetchLogPeruriParams>) => {
      state.filterLogPeruri = action.payload
    },
    resetFilterLogPeruri: (state: IState) => {
      state.filterLogPeruri = initialState.filterLogPeruri
    },
    setFilterConfigSigning: (state: IState, action: PayloadAction<T.IFetchConfigSigningParams>) => {
      state.filterConfigSigning = action.payload
    },
    resetFilterConfigSigning: (state: IState) => {
      state.filterConfigSigning = initialState.filterConfigSigning
    },
    setFilterConfigPaymentDueDate: (state: IState, action: PayloadAction<T.IFetchConfigPaymentDueDateParams>) => {
      state.filterConfigPaymentDueDate = action.payload
    },
    resetFilterConfigPaymentDueDate: (state: IState) => {
      state.filterConfigPaymentDueDate = initialState.filterConfigPaymentDueDate
    },
    setFilterConfigFile: (state: IState, action: PayloadAction<T.IFetchConfigFileParams>) => {
      state.filterConfigFile = action.payload
    },
    resetFilterConfigFile: (state: IState) => {
      state.filterConfigFile = initialState.filterConfigFile
    },
    setMasterSupplyPoint: (state: IState, action: PayloadAction<T.IFetchMasterSupplyPoint>) => {
      try {
        const serializedState = JSON.stringify(action.payload);
        localStorage.setItem('redux-sp-filter', serializedState);
      } catch (e) {
        console.log("err", e)
      }
      state.filterSO = action.payload
      state.filterSupplyPoint = action.payload
    },
    resetMasterSupplyPoint: (state: IState) => {
      localStorage.removeItem('redux-sp-filter');
      state.filterSupplyPoint = initialState.filterSupplyPoint
    },
  },
})

/**
 * Action
 */
export const {
  setFilterLogQueue,
  resetFilterLogQueue,
  setFilterMasterJBPType,
  resetFilterMasterJBPType,
  setFilterMasterJBP,
  resetFilterMasterJBP,
  setFilterMasterPricing,
  resetFilterMasterPricing,
  setIsFetchData,
  setFilterPlantAssignment,
  resetFilterPlantAssignment,
  setFilterPlants,
  resetFilterPlants,
  setFilterSalesOffices,
  resetFilterSalesOffices,
  setFilterSalesAreaAssignment,
  resetFilterSalesAreaAssignment,
  setFilterBasicPrices,
  resetFilterBasicPrices,
  setFilterNonJBPPrices,
  resetFilterNonJBPPrices,
  setFilterIncoterms,
  resetFilterIncoterms,
  setFilterTermOfPayments,
  resetFilterTermOfPayments,
  setFilterTransports,
  resetFilterTransports,
  setFilterBankAccount,
  resetFilterBankAccount,
  setFilterRoute,
  resetFilterRoute,
  setFilterNews,
  resetFilterNews,
  setFilterUser,
  resetFilterUser,
  setFilterRole,
  resetFilterRole,
  setFilterMenu,
  resetFilterMenu,
  setFilterSIPLevel,
  resetFilterSIPLevel,
  setFilterSOLevel,
  resetFilterSOLevel,
  setFilterContractLevel,
  resetFilterContractLevel,
  setFilterUserLevel,
  resetFilterUserLevel,
  setFilterSettingConfig,
  resetFilterSettingConfig,
  setFilterDate,
  resetFilterDate,
  setFilterLogSAP,
  resetFilterLogSAP,
  setFilterLogH2H,
  resetFilterLogH2H,
  setFilterLogAPI,
  resetFilterLogAPI,
  setFilterAuditTrails,
  resetFilterAuditTrails,
  setFilterPPN,
  resetFilterPPN,
  setFilterCustomer,
  resetFilterCustomer,
  setFilterMaterial,
  resetFilterMaterial,
  setFilterConfigLetter,
  resetFilterConfigLetter,
  setFilterConfigOptionalText,
  resetFilterConfigOptionalText,
  setFilterOrders,
  resetFilterOrders,
  setFilterSIPOrders,
  resetFilterSIPOrders,
  setFilterContracts,
  resetFilterContracts,
  setFilterSO,
  resetFilterSO,
  setFilterDelveryOrders,
  resetFilterDelveryOrders,
  setFilterLogMasterData,
  resetFilterLogMasterData,
  setFilterLogAuth,
  resetFilterLogAuth,
  setFilterLogPeruri,
  resetFilterLogPeruri,
  setFilterConfigSigning,
  resetFilterConfigSigning,
  setFilterConfigFile,
  resetFilterConfigFile,
  setMasterSupplyPoint,
  resetMasterSupplyPoint,
  setFilterLogSalesOrder,
  resetFilterLogSalesOrder
} = filterSlice.actions

/**
 * Selector
 */
export const filterSelector = (state: RootState) => state.filterReducer

/**
 * Reducer
 */
export default filterSlice.reducer
